import { SyncStorageKey, syncStorage } from 'utils/environment/sync-storage';

export const preloadedOrder = () => {
  const order = syncStorage.getObject(SyncStorageKey.ORDER);
  return order || {};
};
